export default "__VITE_ASSET__k6LGOmm___"